import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import models from './models';

/**
 * Stores user feedback
 *
* @param {Object} props All parameters to be used in the function
* @param {Object=} props.data The data object to be used in the request to be sent
* @param {function=} props.dispatch Redux dispatcher
* @param {function=} props.error Failed callback function
* @param {function=} props.success Successful callback function
 */

const feedback = (props) => {
  const state = assign(props);
  const model = models.request(state.data);

  fetch(endpoint('/save-feed-back'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        state.success(convert(response.Message));
      } else {
        state.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default feedback;
